.skin-stacked {
  .plyr__controls {
    flex-wrap: wrap;
  }

  .presto-player-progress__marker {
    transform: scale(0.75);
  }

  .plyr__controls {
    justify-content: flex-start;
  }

  .plyr__controls__item.plyr__progress__container {
    order: -1;
    flex: 1 0 100%;
  }

  .plyr__controls__item.plyr__progress__container + :not(.plyr__time),
  .plyr__controls__item.plyr__progress__container + .plyr__time + * {
    margin-left: auto;
  }

  .plyr__controls .plyr__controls__item:first-child {
    margin: 0;
  }

  .plyr__progress {
    height: 19px;
    display: flex;
    align-items: center;
    // --plyr-range-track-height: 3px;
    .plyr__progress__buffer {
      height: 3px;
      transition: all 0.25s ease;
      position: absolute;
      top: calc(50% + 1px);
    }

    input[type='range'] {
      &::-moz-range-track {
        height: 3px;
        transition: all 0.25s ease;
      }
      &::-webkit-slider-runnable-track {
        height: 3px;
        transition: all 0.25s ease;
      }
      &::-ms-track {
        height: 3px;
        transition: all 0.25s ease;
      }
      &::-ms-fill-upper {
        height: 3px;
        transition: all 0.25s ease;
      }
      &::-ms-fill-lower {
        height: 3px;
        transition: height 0.25s ease;
      }

      &::-webkit-slider-thumb {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.25s ease;
      }
      &::-moz-range-thumb {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.25s ease;
      }
      &::-ms-thumb {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.25s ease;
      }
    }
  }

  .plyr__progress__container:hover {
    .presto-player-progress__marker {
      transform: scale(1);
    }
    .plyr__progress {
      .plyr__progress__buffer {
        height: 5px;
        top: calc(50%);
      }
      // --plyr-range-track-height: 5px;
      input[type='range'] {
        overflow: visible;
        &::-moz-range-track {
          height: 5px;
        }
        &::-webkit-slider-runnable-track {
          height: 5px;
        }
        &::-ms-track {
          height: 5px;
        }
        &::-ms-fill-upper {
          height: 5px;
        }
        &::-ms-fill-lower {
          height: 5px;
        }
        &::-webkit-slider-thumb {
          visibility: visible;
          opacity: 1;
        }
        &::-moz-range-thumb {
          visibility: visible;
          opacity: 1;
        }
        &::-ms-thumb {
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
}
